import React from 'react';
import styled from 'styled-components';
import closePng from '../../static/images/close.png';

const PluggableContainer = styled.div`
    flex: 0 0 auto;
    position: relative;
    max-height: 190px;
    width: 100%;
    overflow: hidden;
`;
const CloseBtn = styled.div`
    width: 22px;
    height: 22px;
    background: url(${closePng}) no-repeat center center;
    background-size: 22px 22px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

export function createPlugin(props) {
    const { customComponent, closeChat, resetSession } = props;
    let customized = null;
    if (customComponent) {
        customized = (
            <PluggableContainer>
                <CloseBtn
                    onClick={() => {
                        closeChat();
                        resetSession();
                    }}
                />
                {customComponent}
            </PluggableContainer>
        );
    }
    return customized;
}
